export type LibraryCDMS = string

export const GeneralLibraryCDMS: typeSystemLibraryCDMS = {
    CCP: 'HOE',
    FIN: 'FIN',
}

export type typeSystemLibraryCDMS = {
    CCP: 'HOE'
    FIN: 'FIN'
}
